export enum PolicyTypes {
  PRIVACY_POLICY = 'PRIVACY_POLICY',
  COOKIE_POLICY = 'COOKIE_POLICY',
  TERMS_OF_SERVICE = 'TERMS_OF_SERVICE',
}
